import { Flex, Typography, Image } from 'antd';
import { Container, StyledField } from './style';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Machine, Template } from '../../../../types';
import { ImageContainer } from '../../../../styles/commonStyles';

export interface MachineBasicInfoProps {
  machine: Machine;
  template?: Template;
}

const Field = ({ label, value }: { label?: string; value?: string }) => (
  <StyledField gap={10}>
    <span className="label">{label}</span>
    <span>{value || '-'}</span>
  </StyledField>
);

const MachineBasicInfo = ({ machine, template }: MachineBasicInfoProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Container align="center" gap={16} flex={1}>
      <Flex style={{ backgroundColor: '#fff', height: 90 }}>
        <ImageContainer style={{ width: 120, height: 90 }}>
          <Image
            src={machine?.images?.[0]?.url}
            preview={!!machine?.images?.[0]?.url}
            fallback="/placeholder.png"
          />
        </ImageContainer>
      </Flex>
      <Flex flex={1} vertical gap={16}>
        <Flex gap={20} align="flex-end">
          <Typography.Title level={2} style={{ margin: 0 }}>
            {machine.name}
          </Typography.Title>

          <Field label={t('alias')} value={machine.alias} />
        </Flex>
        <Flex gap={16}>
          <Field label={t('template')} value={template?.name} />
          <Field label={t('machine_type')} value={machine.type} />
          <Field label={t('manufacturer')} value={machine.manufacturer} />
        </Flex>
      </Flex>
    </Container>
  );
};

export default MachineBasicInfo;
